import { useBackendProps } from "@/react/providers";

export const useHeightStyles = () => {
  const { display_header: shouldDisplayHeader = true } = useBackendProps();
  const topBarStyles = shouldDisplayHeader ? "lg:h-[calc(100vh-64px)]" : "";
  const topBarStylesWithMasquerade = "lg:h-[calc(100vh-48px-64px)]";

  return {
    topBarStyles,
    topBarStylesWithMasquerade,
  };
};
